import React from 'react';
import Icon from '../../../components/AppIcon';
import { Card, CardContent } from '../../../components/ui/Card';
import { cn } from '../../../utils/cn';

const WorkflowStats = ({ stats, onStatClick, activeFilter }) => {
  const statCards = [
    { title: 'PENDING', value: stats.pendingLevel1 || 0, icon: 'Clock', color: 'warning', filterType: 'level1' },
    { title: 'Assign Vendor Code', value: stats.approvedMonth || 0, icon: 'CheckCircle', color: 'success', filterType: 'approved_month' },
    { title: 'Rejected', value: stats.rejectedMonth || 0, icon: 'XCircle', color: 'destructive', filterType: 'rejected' },
  ];

  // CampaignOS tones: teal for positive, muted amber/coral for pending/rejected.
  const getColorScheme = (colorType) => {
    const schemes = {
      primary: { iconBg: 'bg-cos-teal', accent: 'bg-cos-teal' },
      success: { iconBg: 'bg-cos-teal', accent: 'bg-cos-teal' },
      warning: { iconBg: 'bg-cos-status-amber', accent: 'bg-cos-status-amber' },
      destructive: { iconBg: 'bg-cos-status-coral', accent: 'bg-cos-status-coral' },
    };
    return schemes[colorType] || schemes.primary;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {statCards.map((stat, index) => {
        const colorScheme = getColorScheme(stat.color);
        const isActive = activeFilter === stat.filterType;
        return (
          <Card
            key={index}
            onClick={() => onStatClick && onStatClick(stat.filterType)}
            className={cn(
              'group relative overflow-hidden cursor-pointer rounded-cos-card bg-white/60 backdrop-blur-cos-glass transition-all duration-300 hover:-translate-y-1',
              isActive ? 'border border-cos-teal shadow-cos-teal-glow-lg' : 'border border-cos-line shadow-cos-glass-sm hover:shadow-cos-glass-md'
            )}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 flex-1 min-w-0">
                  {/* Icon chip */}
                  <div className={cn('relative flex items-center justify-center flex-shrink-0 rounded-xl p-2.5 shadow-cos-glass-sm transition-transform duration-300 group-hover:scale-110', colorScheme.iconBg)}>
                    <Icon name={stat.icon} size={18} className="text-white" />
                  </div>

                  {/* Content */}
                  <div className="min-w-0 flex-1">
                    <p className="mb-1 text-xs font-semibold uppercase tracking-wide text-cos-ink-muted">{stat.title}</p>
                    <h3 className="font-mono text-2xl font-bold tabular-nums tracking-tight text-cos-ink">{stat.value}</h3>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default WorkflowStats;
